module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.947d4eb3.eot";